

















import { Component, Vue } from "vue-property-decorator";
import VueGallerySlideshow from 'vue-gallery-slideshow';

//import Lightbox from 'vue-pure-lightbox';
/*import HelloWorld from "@/components/HelloWorld.vue"; 
import HelloI18n from "@/components/HelloI18n.vue";*/
//import Lightbox from "@/lightbox";

@Component({
  components: {
    VueGallerySlideshow
  }
})
export default class Hotel extends Vue {
	data() {
		return {
			images: [
				'/img-lightbox/hotel_oaxaca-1.jpg',
				'/img-lightbox/hotel_oaxaca-2.jpg',
				'/img-lightbox/hotel_oaxaca-3.jpg',
				'/img-lightbox/hotel_oaxaca-4.jpg',
				'/img-lightbox/hotel_oaxaca-5.jpg',
				'/img-lightbox/hotel_oaxaca-6.jpg',
				'/img-lightbox/hotel_oaxaca-7.jpg',
				'/img-lightbox/hotel_oaxaca-8.jpg',
				'/img-lightbox/hotel_oaxaca-9.jpg',
				'/img-lightbox/hotel_oaxaca-10.jpg',
				'/img-lightbox/hotel_oaxaca-11.jpg',
				'/img-lightbox/hotel_oaxaca-12.jpg',

			],
			index: null,
			
		};
	}
	
	
}
